import Lottie from "react-lottie";
import * as animationDataClosed from "../../assets/lottie/error/closed.json";
import * as animationDataPending from "../../assets/lottie/error/pending.json";
import * as animationDataNotFound from "../../assets/lottie/error/notfound.json";
import { SalonStatusType } from "../../enums/SalonStatusType";
import { Alert, Group, Text } from "@mantine/core";
import { motion } from "framer-motion";

type Props = {
  status: SalonStatusType | "NotFound";
};

const getDefaolutOptions = (status: SalonStatusType | "NotFound") => {
  switch (status) {
    case SalonStatusType.PendingApproval:
      return {
        loop: false,
        autoplay: true,
        animationData: animationDataPending,
        rendererSettings: {
          preserveAspectRatio: "xMidYMid slice",
        },
      };
    case "NotFound":
      return {
        loop: true,
        autoplay: true,
        animationData: animationDataNotFound,
        rendererSettings: {
          preserveAspectRatio: "xMidYMid slice",
        },
      };
    default:
      return {
        loop: true,
        autoplay: true,
        animationData: animationDataClosed,
        rendererSettings: {
          preserveAspectRatio: "xMidYMid slice",
        },
      };
  }
};

const getTitleAndMessage = (status: SalonStatusType | "NotFound") => {
  switch (status) {
    case SalonStatusType.PendingApproval:
      return {
        color: "blue",
        title: "Bu işletme şu anda onay sürecinde!",
        message:
          "İşletme bilgileriniz incelenmektedir. Onay süreci tamamlandığında işletmeniz yayına açılacaktır. Lütfen onay durumunuzu kontrol etmek için daha sonra tekrar ziyaret ediniz.",
      };
    case "NotFound":
      return {
        color: "yellow",
        title: "İşletme Bulunamadı",
        message:
          "Aradığınız işletme bulunamadı. Lütfen URL'deki işletme adını kontrol edin.",
      };
    default:
      return {
        color: "red",
        title: "Bu işletme şu anda hizmete kapalı!",
        message:
          "Ziyaretiniz için teşekkürler. Bu işletme şu anda hizmet vermemektedir. Lütfen daha sonra tekrar kontrol ediniz.",
      };
  }
};

const ErrorStatusFullPage = ({ status }: Props) => {
  const defaultOptions = getDefaolutOptions(status);
  const { title, message, color } = getTitleAndMessage(status);
  return (
    <div
      className="flex flex-col items-center justify-center px-4 bg-gradient-to-t from-gray-900 to-blue-950"
      style={{ minHeight: "100vh" }}
    >
      <Lottie
        options={defaultOptions}
        style={{ width: "100%", maxWidth: "200px" }}
      />
      <div className="max-w-lg">
        <motion.div
          className="relative"
          initial={{
            y: 100,
            opacity: 0,
          }}
          animate={{
            y: 0,
            opacity: 1,
          }}
          transition={{
            duration: 0.5,
            ease: "easeInOut",
          }}
        >
          <Alert color={color} variant="light" radius="md">
            <Group gap="xs" wrap="nowrap" align="flex-start">
              <Text fw={600} color="white">
                {title}
              </Text>
            </Group>
            <Text mt={4} color="white">
              {message}
            </Text>
          </Alert>
        </motion.div>
      </div>
    </div>
  );
};

export default ErrorStatusFullPage;
